import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import * as VideoExpress from '@vonage/video-express';
import MuteAudioButton from 'components/MuteAudioButton';
import MuteVideoButton from 'components/MuteVideoButton';
import CombineAudioButton from 'components/CombineAudio';
// import SpeakerButton from 'components/SpeakerButton';
import SpeakerSelector from 'components/SpeakerSelector';
import RecordingButton from 'components/RecordingButton';
import LayoutButton from 'components/LayoutButton';
import MuteAll from 'components/MuteAllButton';
import ReactionsButton from 'components/ReactionsButton';
import HlsScreenSharingButton from 'components/HlsScreenSharingButton';
import EndCallButton from 'components/EndCallButton';
import VideoFilterButton from 'components/VideoFilterButton';
import styles from './styles';
import { useParams } from 'react-router';
import { useTheme } from '@material-ui/core';
import CombineVideoButton from 'components/CombineVideo';
import MoreOptionsButton from 'components/MoreOptionsButton';
import LayoutPanel from 'components/LayoutPanel';
import { useSelector, useDispatch } from 'react-redux';
import CoHostButton from 'components/CoHostButton';
import { canControlBroadcast } from 'utils';
import {
  SET_LOCAL_AUDIO,
  SET_LOCAL_VIDEO,
  SET_BACKGROUND_FILTER,
} from 'store/WaitingRoom/waitingRoomAction';
import HlsFilterButton from 'components/HlsFilterComponent';
import HlsAnalytics from 'components/HlsAnalytics';
// import { GET_PARTICIPANTS_LIST } from 'store/ParticipantsList/participantsListAction';
import { SET_RAISE_HAND } from 'store/VideoRoom/videoRoomAction';
import axios from 'axios';
import StreamButton from 'components/StreamButton';
import ScreenShareLayoutButton from 'components/ScreenShareLayout';
import RecordingLayoutButton from 'components/RecordingLayout';
import { IconButton } from '@material-ui/core';

import Tooltip from '@material-ui/core/Tooltip';

import Badge from '@material-ui/core/Badge';
import ChatIcon from '@material-ui/icons/Chat';

export default function HlsToolBar({
  isScreenSharing,
  startScreenSharing,
  stopScreenSharing,
  cameraPublishing,
  audioPublishing,
  hlsData,
  OT,
  Publisher,
  session,
  stats,
  videoKbps,
  audioKbps,
  setBroadcastType,
  setSelectedLayouts,
  isCurrentHost,
  setOpen,
  open,
  setShowNotificationChat,
  showNotificationChat,
  presentationId,
  showControlPanel,
  onToggleControlPanel
}) {
  const titleToolTip = 'Chat';

  const classes = styles();
  let room;
  let filterName = '';
  let filterPayload = '';
  const localClasses = styles();
  const dispatch = useDispatch();
  const [hlsSession, setHlsSession] = useState();
  const theme = useTheme();
  const isMobileWidth = useMediaQuery(theme.breakpoints.down('xs'));
  const [areAllMuted, setAllMuted] = useState(false);
  const userData = JSON.parse(sessionStorage.getItem('userData'));
  const [showLayoutPanel, setShowLayoutPanel] = useState(
    sessionStorage.getItem('layouts') === 'true'
  );

  const handleMuteAll = () => {
    if (!session) {
      console.log('Session not available');
      return;
    }

    if (!areAllMuted) {
      session.signal(
        {
          type: 'muteAll',
          data: JSON.stringify({ muted: true }),
        },
        (error) => {
          if (error) {
            console.error('Error sending mute signal:', error);
            console.log('Failed to mute all participants');
          } else {
            console.log('Mute all signal sent successfully');
            setAllMuted(true);
            console.log('All participants muted');
          }
        }
      );
    } else {
      session.signal(
        {
          type: 'muteAll',
          data: JSON.stringify({ muted: false }),
        },
        (error) => {
          if (error) {
            console.error('Error sending unmute signal:', error);
            console.log('Failed to unmute participants');
          } else {
            console.log('Unmute signal sent successfully');
            setAllMuted(false);
            console.log('Participants can now unmute');
          }
        }
      );
    }
  };

  const getCurrentAudioOutput = async () => {
    try {
      const currentAudioOutput = await OT.getActiveAudioOutputDevice();
      return currentAudioOutput.deviceId;
    } catch (e) {
      return e;
    }
  };
  const toggleOpen = () => {
    setOpen(!open);
    // setOpenchat(!openchat);
    setShowNotificationChat(false);
  };

  const changeAudioOutput = async (audioOutputDeviceId) => {
    await OT.setAudioOutputDevice(audioOutputDeviceId);
  };
  const changeVideoSource = (videoDeviceId) => {
    if (Publisher) {
      Publisher.setVideoSource(videoDeviceId);
      localStorage.setItem('selectedVideoDevice', videoDeviceId);
    }
  };

  const getVideoSource = () => {
    const savedDeviceId = localStorage.getItem('selectedVideoDevice');
    return savedDeviceId ? { deviceId: savedDeviceId } : null;
  };

  const state = useSelector((state) => state);
  const toggleVideo = () => {
    if (Publisher) {
      if (state.waitingRoomReducer.localVideo) {
        Publisher.publishVideo(false);
        dispatch({ type: SET_LOCAL_VIDEO, payload: false });
        localStorage.setItem('localVideo', false);
      } else {
        Publisher.publishVideo(true);
        dispatch({ type: SET_LOCAL_VIDEO, payload: true });
        dispatch({
          type: SET_BACKGROUND_FILTER,
          payload: { filterName, filterPayload },
        });
        localStorage.setItem('localVideo', true);
      }
    }
  };

  const getAudioSource = async () => {
    if (Publisher) {
      const audioDevice = await Publisher.getAudioSource();
      return audioDevice.deviceId;
    }
  };
  const changeAudioSource = (audioId) => {
    Publisher.setAudioSource(audioId);
  };
  const toggleAudio = () => {
    if (Publisher) {
      if (state.waitingRoomReducer.localAudio) {
        Publisher.publishAudio(false);
        dispatch({ type: SET_LOCAL_AUDIO, payload: false });
        localStorage.setItem('localAudio', false);
      } else {
        Publisher.publishAudio(true);
        dispatch({ type: SET_LOCAL_AUDIO, payload: true });
        localStorage.setItem('localAudio', true);
      }
    }
  };

  useEffect(() => {
    if (hlsData) {
      setHlsSession({ roomId: hlsData?.id });
    }
  }, [hlsData]);
  return (
    <>
      {isMobileWidth && (
        <div className={classes.toolbarMobileContainer}>
          <CombineAudioButton
            toggleAudio={toggleAudio}
            hasAudio={state.waitingRoomReducer.localAudio}
            classes={classes}
            changeAudioSource={changeAudioSource}
            getAudioSource={getAudioSource}
            audioPublishing={audioPublishing}
            changeAudioOutput={changeAudioOutput}
            getCurrentAudioOutput={getCurrentAudioOutput}
          />

          <CombineVideoButton
            toggleVideo={toggleVideo}
            hasVideo={state.waitingRoomReducer.localVideo}
            classes={classes}
            getVideoSource={getVideoSource}
            cameraPublishing={cameraPublishing}
            changeVideoSource={changeVideoSource}
            Publisher={Publisher}
          />
          {canControlBroadcast() && (
            <Tooltip title={showControlPanel ? "Hide Control Panel" : "Show Control Panel"} aria-label="control-panel">
              <IconButton
                onClick={onToggleControlPanel}
                edge="start"
                color="inherit"
                aria-label="control-panel"
                className={classes.infoButton}
                style={{ opacity: showControlPanel ? 1 : 0.5 }}
              >
                🎛️
              </IconButton>
            </Tooltip>
          )}
        </div>
      )}
      {!isMobileWidth && (
        <div
          className={classes.toolbarContainer}
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: `${sessionStorage.getItem('layouts') == 'true' ? '112px' : '65px'
              }`,
          }}
        >
          {showLayoutPanel && userData.role !== 'Studio Guest' && (
            <LayoutPanel
              isScreenSharing={isScreenSharing}
              setSelectedLayouts={setSelectedLayouts}
            />
          )}

          <div className={classes.toolbarContainerWrapper}>
            <CombineAudioButton
              toggleAudio={toggleAudio}
              hasAudio={state.waitingRoomReducer.localAudio}
              classes={classes}
              changeAudioSource={changeAudioSource}
              getAudioSource={getAudioSource}
              audioPublishing={audioPublishing}
              changeAudioOutput={changeAudioOutput}
              getCurrentAudioOutput={getCurrentAudioOutput}
            />

            <CombineVideoButton
              toggleVideo={toggleVideo}
              hasVideo={state.waitingRoomReducer.localVideo}
              classes={classes}
              getVideoSource={getVideoSource}
              cameraPublishing={cameraPublishing}
              changeVideoSource={changeVideoSource}
              Publisher={Publisher}
            />
            {/* {OT.hasMediaProcessorSupport() && (
            <HlsFilterButton classes={classes} Publisher={Publisher} />
          )} */}
            {/* <SpeakerButton
          cameraPublishing={cameraPublishing}
          changeAudioOutput={changeAudioOutput}
          getCurrentAudioOutput={getCurrentAudioOutput}
          classes={classes}
        /> */}
            {/* {!sessionStorage.getItem('recording') && (
            <SpeakerSelector
              room={room}
              changeAudioOutput={changeAudioOutput}
              getCurrentAudioOutput={getCurrentAudioOutput}
              classes={classes}
            />
          )} */}
            {userData.role !== 'Studio Guest' && (
              <RecordingButton room={hlsSession} classes={classes} />
            )}

            <HlsScreenSharingButton
              isScreenSharing={isScreenSharing}
              startScreenSharing={startScreenSharing}
              stopScreenSharing={stopScreenSharing}
              classes={classes}
              isCurrentHost={isCurrentHost}
            />

            {/* <ReactionsButton
            reactionHand={handleRaiseHand}
            classes={classes}
            room={room}
          /> */}
            {/* <LayoutButton classes={classes} room={room} /> */}
            {!sessionStorage.getItem('recording') &&
              userData.role !== 'Studio Guest' &&
              sessionStorage.getItem('IsHost') == 1 && (
                <>
                  <MuteAll
                    handleMuteAll={handleMuteAll}
                    areAllMuted={areAllMuted}
                    classes={classes}
                  />
                  {/* {sessionStorage.getItem('broadcastId') == null && (
                <StreamButton
                  classes={classes}
                  room={room}
                  setBroadcastType={setBroadcastType}
                />
              )} */}
                </>
              )}
            {/* {sessionStorage.getItem('broadcastId') !== null && ( */}
            {userData.role !== 'Studio Guest' && (
              <ScreenShareLayoutButton
                classes={classes}
                room={room}
                setShowLayoutPanel={setShowLayoutPanel}
              />
            )}

            {/* )} */}

            {sessionStorage.getItem('recording') && (
              <RecordingLayoutButton classes={classes} room={room} />
            )}
            {!sessionStorage.getItem('recording') &&
              (
                <HlsAnalytics
                  classes={classes}
                  room={room}
                  stats={stats}
                  videoKbps={videoKbps}
                  audioKbps={audioKbps}
                />
              )}
            <CoHostButton
              classes={classes}
              presentationId={presentationId}
            />
            {canControlBroadcast() && (
              <Tooltip title={showControlPanel ? "Hide Control Panel" : "Show Control Panel"} aria-label="control-panel">
                <IconButton
                  onClick={onToggleControlPanel}
                  edge="start"
                  color="inherit"
                  aria-label="control-panel"
                  className={classes.infoButton}
                  style={{ opacity: showControlPanel ? 1 : 0.5 }}
                >
                  🎛️
                </IconButton>
              </Tooltip>
            )}
            {/* <EndCallButton classes={classes} handleEndCall={endCall} /> */}
            {showNotificationChat ? (
              <Tooltip title={titleToolTip} aria-label='add'>
                <Badge badgeContent={1} color='secondary'>
                  <IconButton
                    onClick={toggleOpen}
                    edge='start'
                    color='inherit'
                    aria-label='mic'
                    className={localClasses.infoButton}
                  >
                    <ChatIcon fontSize='inherit' />
                  </IconButton>
                </Badge>
              </Tooltip>
            ) : (
              <Tooltip title={titleToolTip} aria-label='add'>
                <IconButton
                  onClick={toggleOpen}
                  edge='start'
                  color='inherit'
                  aria-label='mic'
                  className={classes.infoButton}
                >
                  <ChatIcon fontSize='inherit' />
                </IconButton>
              </Tooltip>
            )}
          </div>
        </div>
      )}
    </>
  );
}
